import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "ordinalDate",
  standalone: true
})
export class OrdinalDatePipe implements PipeTransform {
  transform(value: string | Date | number | null | undefined): string {
    if (!value) {
      return "";
    }
    
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return "";
    } // Fallback for invalid dates

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();

    // Determine the correct suffix (st, nd, rd, th)
    let suffix = "th";
    const lastDigit = day % 10;
    const isTeen = day > 10 && day < 14; // Catch 11th, 12th, 13th

    if (!isTeen) {
      if (lastDigit === 1) {
        suffix = "st";
      } else if (lastDigit === 2) {
        suffix = "nd";
      } else if (lastDigit === 3) {
        suffix = "rd";
      }
    }

    // Returns formatted string: "Feb 26th, 2026"
    return `${month} ${day}${suffix}, ${year}`;
  }
}